<template>
  <v-dialog width="70%" persistent :value="manageBookingDialog">
    <v-card>
      <v-alert class="white--text" color="error"
               v-if="!activeBooking.isNewBookingSystem && activeBooking.paymentMethod === 'Card'"><strong>You are
        editing a booking made in the old system with a card payment. This will not work due to changes in the Stripe
        platform. Please use the old system to affect this change!</strong></v-alert>
      <v-card-title>Manage Booking <span class="ml-4" v-if="activeBooking.xeroInvoiceNumber"><a
          :href="activeBooking.xeroInvoiceLink" target="_blank">{{ activeBooking.xeroInvoiceNumber }}</a></span>
        <span v-if="invoice" class="ml-2">Invoice Status: {{ invoice.body.invoices[0].status }}</span>
        <p class="display-1" v-if="activeBooking.isPayingCash">THIS IS A CASH PAYMENT - ENSURE CASH IS COLLECTED</p>
        <v-layout>
          <v-spacer />
          <v-btn v-if="invoice && invoice.body.invoices[0].status === 'DRAFT'" color="success" :loading="isSaving" :disabled="isSaving" @click="approveInvoice">Approve & Send Invoice</v-btn>
          <v-btn color="success" :loading="isSaving" :disabled="isSaving" @click="assignNewInvoiceDialog = true">Assign Different Invoice</v-btn>
          <v-btn @click="previewTheEmail" icon color="info"><v-icon>mdi-email-search</v-icon></v-btn>
        </v-layout>
      </v-card-title>
      <v-card-subtitle v-if="activeBooking.parentBookingId">Parent Booking - <a
          @click="loadParentBooking(activeBooking.parentBookingId)" style="cursor: pointer">Click Here</a>
      </v-card-subtitle>
      <v-card-subtitle v-if="activeBooking.primaryTrackingId">Parent Booking - <a
          @click="loadParentBooking(activeBooking.primaryTrackingId)" style="cursor: pointer">Click Here</a>
      </v-card-subtitle>
      <v-card-text>
        <v-alert v-if="activeBooking.customer.canTakePayment" type="info">This customer has agreed for payment to be taken at anytime</v-alert>
        <v-alert v-if="isSaving" type="info">
          Making Booking
          <v-progress-circular class="float-right" indeterminate color="white"></v-progress-circular>
        </v-alert>
        <v-alert v-if="isSavingCustomerToXero" type="info">
          Validating Customer in Xero
          <v-progress-circular class="float-right" indeterminate color="white"></v-progress-circular>
        </v-alert>
        <v-alert v-if="isSendingToXero" type="info">
          Creating Invoice in Xero
          <v-progress-circular class="float-right" indeterminate color="white"></v-progress-circular>
        </v-alert>
        <v-stepper v-model="e1">
          <v-stepper-header>
            <v-stepper-step step="1" editable>Customer Details</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="2" editable>Valet Details</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="3" editable>Payment Details</v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1">
              <v-card class="mb-12">
                <customer-details :booking="activeBooking"
                />
              </v-card>
            </v-stepper-content>

<!--            <v-stepper-content step="2">-->
<!--              <v-card class="mb-12">-->
<!--                <vehicle-details :booking="activeBooking"/>-->
<!--              </v-card>-->
<!--            </v-stepper-content>-->

            <v-stepper-content step="2">
              <v-card class="mb-12">
                <valet-details :booking="activeBooking"/>
              </v-card>
            </v-stepper-content>

            <v-stepper-content step="3">
              <v-card class="mb-12">
                <payment-details v-on:update-refs="updatePaymentRefs" :booking="activeBooking"/>
              </v-card>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card-text>
      <v-card-actions>
        <v-checkbox v-if="activeBooking._id" @click="lockBooking" class="ml-4"
                    :label="activeBooking.isApproved ? `Tick to unlock booking` : `Tick to approve and lock booking`"
                    v-model="activeBooking.isApproved"/>
        <v-checkbox v-if="activeBooking._id" class="ml-4"
                    label="Quality Control Complete" v-model="activeBooking.qcComplete"/>
        <v-checkbox v-if="activeBooking._id" :disabled="activeBooking.isApproved || activeBooking.isGiftVoucher" class="ml-4"
                    label="Tick to deduct from weekly turnover" v-model="activeBooking.isDeducatable"/>
        <v-checkbox :disabled="activeBooking.parentBookingId || activeBooking.isApproved" class="ml-4"
                    label="Contribute to daily sales target" v-model="activeBooking.recordSale"/>
        <v-spacer/>
        <v-btn color="primary" text @click="cancelBooking">Cancel</v-btn>
        <!--                <v-btn v-if="activeBooking._id" :loading="isSaving" :disabled="isSaving || !isCustomerSelected || !isBookingValid" color="info" @click="createSplitBooking">Split Booking</v-btn>-->
        <v-btn v-if="!activeBooking.parentBookingId && activeBooking._id && activeBooking.xeroValetTrackingId !== 'Reschedule'" color="success" @click="createRepeat">
          Create Repeat
        </v-btn>
        <v-btn v-if="activeBooking._id" color="error" @click="cancelTheBooking" :loading="isSaving" :disabled="isSaving">
          Cancel Booking
        </v-btn>
        <v-btn v-if="activeBooking._id && activeBooking.xeroValetTrackingId !== 'Reschedule'" color="success" @click="rescheduleBooking" :loading="isSaving" :disabled="isSaving">
          Reschedule
        </v-btn>
        <v-btn v-if="activeBooking._id && activeBooking.xeroValetTrackingId === 'Reschedule' || activeBooking.xeroValetTrackingId === 'Cancellation'" color="success" @click="rebookReschedule" :loading="isSaving" :disabled="isSaving">
          Rebook
        </v-btn>
        <v-btn :loading="isSaving"
               :disabled="isSaving || !isCustomerSelected || !isBookingValid || (!activeBooking.isNewBookingSystem && activeBooking.paymentMethod === 'Card')"
               color="primary" @click="saveBookingFirstStep">Save Booking
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Unlock this booking?</v-card-title>
        <v-card-text>Unlocking this booking will remove it from the week sheet reports.
          <v-text-field label="Enter manager code to unlock" v-model="unlockCode" />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog = false">Cancel</v-btn>
          <v-btn :loading="isSaving" :disabled="isSaving || unlockCode !== 'mw5544tg2019kg'" color="green darken-1" class="white--text" @click="doUnlockBooking">Unlock</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="confirmDialog" persistent width="40%">
      <v-card>
        <v-card-title class="headline">Confirm booking</v-card-title>
        <v-card-text>
          Confirm below if you want to create an invoice
          <v-checkbox label="Auto approve and send invoice to customer?" v-model="autoApproveSend" />
          <v-btn @click="previewTheEmailRemote" icon color="info"><v-icon>mdi-email-search</v-icon></v-btn>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="confirmDialog = false">Cancel</v-btn>
          <v-btn :loading="isSaving" :disabled="isSaving" color="red darken-1" class="white--text" @click="saveBooking(false)">Create without Invoice</v-btn>
          <v-btn :loading="isSaving" :disabled="isSaving" color="green darken-1" class="white--text" @click="saveBooking(true)">Create with Invoice</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="rebook" persistent width="40%">
      <v-card>
        <v-card-title class="headline">Rebook this booking</v-card-title>
        <v-card-text>
          <v-select clearable
                    v-model="activeBooking.xeroValetTrackingId" label="Select Technician for Commission Tracking"
                    item-text="name" item-value="name" :items="technicians"/>
          <v-datetime-picker label="Start Date/Time" v-model="localStartDate"
                             :timePickerProps="{format: '24hr'}">
            <template v-slot:dateIcon>
              <v-icon>mdi-calendar</v-icon>
            </template>
            <template v-slot:timeIcon>
              <v-icon>mdi-clock-outline</v-icon>
            </template>
          </v-datetime-picker>
          <v-datetime-picker v-if="localStartDate" label="End Date/Time"
                             v-model="localEndDate"
                             :datePickerProps="{min: localStartDate}"
                             :timePickerProps="{format: '24hr'}">
            <template v-slot:dateIcon>
              <v-icon>mdi-calendar</v-icon>
            </template>
            <template v-slot:timeIcon>
              <v-icon>mdi-clock-outline</v-icon>
            </template>
          </v-datetime-picker>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="rebook = false">Cancel</v-btn>
          <v-btn :loading="isSaving" :disabled="isSaving" color="success" class="white--text" @click="saveBooking(activeBooking.isXeroBooking)">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="assignNewInvoiceDialog" persistent width="40%">
      <v-card>
        <v-card-title class="headline">Assign different invoice</v-card-title>
        <v-card-text>
          <v-text-field v-model="newInvoiceNumber" label="Enter new invoice number" />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="assignNewInvoiceDialog = false">Cancel</v-btn>
          <v-btn :loading="isSaving" :disabled="isSaving" color="green darken-1" class="white--text" @click="assignNewInvoice">Assign Invoice</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="previewEmailDialog" persistent width="60%">
      <v-card>
        <v-card-title class="headline">Email Preview</v-card-title>
        <v-card-text>
          <v-container fluid>
            <v-row>
              <v-col cols="12">
                <div style="width: 100%" v-html="emailPreview"></div>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="previewEmailDialog = false">Done</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-dialog>
</template>

<script>
import {mapState, mapActions, mapMutations} from "vuex";
import CustomerDetails from "./booking-steps/CustomerDetails";
import {CustomersHttp} from "@/http/CustomersHttp";
// import VehicleDetails from "./booking-steps/VehicleDetails";
import ValetDetails from "./booking-steps/ValetDetails";
import PaymentDetails from "./booking-steps/PaymentDetails";
import {BookingsHttp} from "@/http/BookingsHttp";
import {XeroHttp} from "@/http/XeroHttp";
import {PaymentsHttp} from "@/http/PaymentsHttp";
import EventBus from "../../EventBus";

export default {
  name: "BookingModal",
  components: {PaymentDetails, ValetDetails, CustomerDetails},
  mounted() {
    EventBus.$on('price-updated-manually', (price) => {
      // eslint-disable-next-line no-console
      console.log(price);
      this.totalToCharge = price;
    });
  },
  data() {
    return {
      isSaving: false,
      isSendingToXero: false,
      isSavingCustomerToXero: false,
      isCustomerSelected: false,
      isBookingValid: false,
      e1: null,
      totalToCharge: 0,
      invoice: null,
      dialog: false,
      unlockCode: '',
      confirmDialog: false,
      rebook: false,
      localStartDate: null,
      localEndDate: null,
      autoApproveSend: false,
      assignNewInvoiceDialog: false,
      newInvoiceNumber: null,
      previewEmailDialog: false,
      emailPreview: ""
    }
  },
  computed: {
    ...mapState("bookings", ["manageBookingDialog", "activeBooking"]),
    ...mapState("xero", ["services", "periods", "technicians", "accounts"]),
  },
  watch: {
    localStartDate(newVal) {
      this.activeBooking.startDate = new Date(newVal);
      if (newVal) {
        const momentStart = this.$moment(this.activeBooking.startDate);
        const momentEnd = this.$moment(this.activeBooking.endDate);
        this.endDateError = !momentEnd.isSame(momentStart, 'day');
      }
    },
    localEndDate(newVal) {
      this.activeBooking.endDate = new Date(newVal);
      if (newVal) {
        const momentStart = this.$moment(this.activeBooking.startDate);
        const momentEnd = this.$moment(this.activeBooking.endDate);
        this.endDateError = !momentEnd.isSame(momentStart, 'day');
      }
    },
    manageBookingDialog: {
      async handler(newVal) {
        if (newVal) {
          if (this.activeBooking.price) {
            EventBus.$emit('price-change', this.activeBooking.price);
          }
          if (!this.activeBooking.selectedServices) {
            EventBus.$emit('reset-valet-details');
          }
          if (this.activeBooking.xeroInvoiceNumber) {
            this.invoice = await XeroHttp.getInvoice(this.activeBooking.xeroInvoiceNumber).then(result => result.data);
          }
        }
      },
      deep: true,
      immediate: true
    },
    activeBooking: {
      handler(newVal) {
        if (newVal.startDate) {
          const tempDate = this.$moment(newVal.startDate);
          if (tempDate) {
            this.localStartDate = tempDate.format('YYYY-MM-DD HH:mm');
          }
        }
        if (newVal.endDate) {
          const tempDate = this.$moment(newVal.endDate);
          if (tempDate) {
            this.localEndDate = tempDate.format('YYYY-MM-DD HH:mm');
          }
        }
        this.isBookingValid = !(!newVal.purpose || newVal.purpose.length === 0 || !newVal.canBeChanged || !newVal.hasPower || !newVal.hasWater ||
            !newVal.price || !newVal.startDate || !newVal.endDate || !newVal.paymentMethod
            || !newVal.bookingMadeBy || (!newVal.vehicles && newVal.selectedServices.length === 0) || (!newVal.parentBookingId && newVal.vehicles && newVal.vehicles.length === 0));

        if (newVal.customer) {
          this.isCustomerSelected = true;
        }

        if (!newVal.isXeroBooking) {
          this.isBookingValid = true;
        }

        if (newVal._id) {
          EventBus.$emit('price-change', this.activeBooking.price);
        }

        if (!newVal._id) {
          this.activeBooking.recordSale = true;
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    ...mapActions("bookings", ["setManageBookingDialog", "setActiveBooking", "setBookings"]),
    ...mapActions("repeats", ["setUpcomingRepeatsDialog", "setActiveRepeat", "setManageRepeatDialog"]),
    ...mapMutations("app", ["setToast"]),
    async updatePaymentRefs(ref) {
      this.activeBooking.paymentRef.push(ref);
      await PaymentsHttp.updateCharges(this.activeBooking.xeroInvoiceNumber, this.activeBooking.paymentRef);
    },
    async previewTheEmail() {
      this.previewEmailDialog = true;
      const { data } = await BookingsHttp.previewBooking(this.activeBooking._id);
      this.emailPreview = data;
    },
    async previewTheEmailRemote() {
      this.previewEmailDialog = true;
      const { data } = await BookingsHttp.previewBookingNotSaved(this.activeBooking);
      this.emailPreview = data;
    },
    async cancelBooking() {
      this.e1 = 1;
      EventBus.$emit('clear-payment');
      EventBus.$emit('reset-valet-details');
      this.invoice = null;
      await this.setActiveBooking({isXeroBooking: true, customer: {}, vehicle: null});
      await this.setManageBookingDialog(false);
    },
    saveBookingFirstStep() {
        if (!this.activeBooking._id || (this.activeBooking._id && !this.activeBooking.isXeroBooking)) {
          this.confirmDialog = true
        } else {
          this.saveBooking(this.activeBooking.isXeroBooking);
        }
    },
    async lockBooking() {
      if (!this.activeBooking.isApproved) {
        try {
          this.isSaving = true;
          this.activeBooking.isApproved = true;
          await BookingsHttp.updateBooking(this.activeBooking);
          await this.setBookings(this.activeBooking.startDate);
          this.setToast({color: 'success', text: 'Booking locked successfully', show: true});
        } catch (e) {
          this.setToast({color: 'error', text: e.response.data, show: true})
        } finally {
          this.isSaving = false;
        }
      } else {
        this.dialog = true;
      }
    },
    async doUnlockBooking() {
      try {
        this.isSaving = true;
        this.activeBooking.isApproved = false;
        await BookingsHttp.updateBooking(this.activeBooking);
        await this.setBookings(this.activeBooking.startDate);
        this.setToast({color: 'success', text: 'Booking un-locked successfully', show: true});
        this.dialog = false;
      } catch (e) {
        this.setToast({color: 'error', text: e.response.data, show: true})
      } finally {
        this.isSaving = false;
      }
    },
    async assignNewInvoice() {
      if (this.newInvoiceNumber) {
        const invoice = await XeroHttp.getInvoice(this.newInvoiceNumber).then(result => result.data);
        if (invoice && invoice.body.invoices.length > 0) {
          this.activeBooking.xeroInvoiceNumber = this.newInvoiceNumber;
          this.activeBooking.isXeroBooking = true;
          this.activeBooking.xeroInvoiceLink = `https://go.xero.com/AccountsReceivable/Edit.aspx?InvoiceID=${invoice.body.invoices[0].invoiceID}`;
          this.assignNewInvoiceDialog = false;
          await this.saveBooking(true);
        }
      }
    },
    async saveBooking(isXeroBooking) {
      if (this.activeBooking.paymentMethod === "Card" && !this.activeBooking.paymentRef) {
        this.setToast({color: 'error', text: "STOP! You've not taken a payment you idiot", show: true});
      } else if (this.activeBooking.xeroAccountName !== 'Sales (30%)' && !this.activeBooking.xeroAccountCodeReason && !this.activeBooking.selectedServices) {
        this.setToast({color: 'error', text: "STOP! You've not said what the reason is for the commission basis", show: true});
      } else {
        this.isSaving = true;
        let b = {...this.activeBooking};
        b.isXeroBooking = isXeroBooking;
        if (this.totalToCharge) {
          b.totalCharged = this.totalToCharge.toString();
        }

        if (this.totalToCharge === 0) {
          b.totalCharged = this.totalToCharge.toString();
        }

        if (b.price === "") {
          b.price = 0;
        }

        try {
          let booking;
          b.isNewBookingSystem = true;
          b.isRepeat = false;
          if (!b._id) {
            booking = await BookingsHttp.createBooking(b).then(result => result.data);
            b = await BookingsHttp.getSingleBooking(booking).then(result => result.data);
          } else {
            await BookingsHttp.updateBooking(b);
            b = await BookingsHttp.getSingleBooking(b._id).then(result => result.data);
          }

          if (b.isXeroBooking && !b.isApproved) {
            this.isSavingCustomerToXero = true;
            const xeroCustomer = await XeroHttp.findCustomer(b.customer.email).then(result => result.data);
            if (!xeroCustomer || xeroCustomer.body.contacts.length === 0) {
              await XeroHttp.createCustomer(b.customer);
            } else {
              await CustomersHttp.updateCustomer(b.customer);
            }
            this.isSavingCustomerToXero = false;
            this.isSendingToXero = true;
            if (!b._id || (!b.xeroInvoiceNumber && b.isXeroBooking)) {
              const invoice = await XeroHttp.createInvoice(b).then(result => result.data);
              b.isXeroBooking = true;
              b.xeroInvoiceLink = `https://go.xero.com/AccountsReceivable/Edit.aspx?InvoiceID=${invoice.body.invoices[0].invoiceID}`;
              b.xeroInvoiceNumber = invoice.body.invoices[0].invoiceNumber;
              if (!b._id) {
                b._id = booking;
              }
              await BookingsHttp.updateBooking(b);
              // eslint-disable-next-line no-console
              console.log('PRE-UPDATE Charge 1');
              if (b.paymentMethod === 'Card') {
                // eslint-disable-next-line no-console
                console.log('UPDATE Charge 1');
                //Update payments
                await PaymentsHttp.updateCharges(b.xeroInvoiceNumber, b.paymentRef);
              }
              if (this.autoApproveSend) {
                await XeroHttp.approveSendBooking(invoice.body.invoices[0].invoiceNumber, b);
              }
            } else {
              if (this.invoice && this.invoice.body.invoices.length > 0 && this.invoice.body.invoices[0].status === 'PAID') {
                this.isSendingToXero = false;
              } else if (!b.parentBookingId) {
                // eslint-disable-next-line no-console
                console.log('PRE-UPDATE Charge 2');
                if (b.paymentMethod === 'Card') {
                  // eslint-disable-next-line no-console
                  console.log('UPDATE Charge 2');
                  //Update payments
                  await PaymentsHttp.updateCharges(b.xeroInvoiceNumber, b.paymentRef);
                }
                await XeroHttp.updateInvoice(b);
                this.isSendingToXero = false;
              }
            }
          }

          EventBus.$emit('clear-payment');
          EventBus.$emit('reset-valet-details');
          this.e1 = 1;
          await this.setBookings(b.startDate);
          await this.setActiveBooking({isXeroBooking: true, customer: {}, isNewBookingSystem: true, vehicle: null});
          await this.setManageBookingDialog(false);
          this.newInvoiceNumber = null;
          this.setToast({color: 'success', text: 'Booking saved successfully', show: true});
          this.confirmDialog = false;
        } catch (err) {
          this.setToast({color: 'error', text: err.response.data, show: true})
        } finally {
          this.isSaving = false;
          this.isSavingCustomerToXero = false;
          this.isSendingToXero = false;
        }
      }
    },
    async createRepeat() {
      await this.setActiveRepeat({
        originalBookingName: this.activeBooking.customer.companyName,
        originalBookingId: this.activeBooking._id,
        nextDate: this.activeBooking.startDate,
        lastBooked: this.activeBooking.startDate,
      });
      await this.setManageRepeatDialog(true);
    },
    async rescheduleBooking() {
      try {
        this.isSaving = true;
        await BookingsHttp.setBookingToReschedule(this.activeBooking._id);
        await this.setBookings(this.activeBooking.startDate);
        await this.setActiveBooking({isXeroBooking: true, customer: {}, isNewBookingSystem: true, vehicle: null});
        await this.setManageBookingDialog(false);
        this.setToast({color: 'success', text: 'Booking saved successfully', show: true});
      } catch (e) {
        this.setToast({color: 'error', text: e.response.data, show: true})
      } finally {
        this.isSaving = false;
      }
    },
    rebookReschedule() {
      this.rebook = true;
    },
    async cancelTheBooking() {
      try {
        this.isSaving = true;
        await BookingsHttp.setBookingToCancel(this.activeBooking._id);
        await this.setBookings(this.activeBooking.startDate);
        await this.setActiveBooking({isXeroBooking: true, customer: {}, isNewBookingSystem: true, vehicle: null});
        await this.setManageBookingDialog(false);
        this.setToast({color: 'success', text: 'Booking cancelled successfully', show: true});
      } catch (e) {
        this.setToast({color: 'error', text: e.response.data, show: true})
      } finally {
        this.isSaving = false;
      }
    },
    async loadParentBooking(id) {
      this.e1 = 1;
      await this.setManageBookingDialog(false);
      await this.setActiveBooking(await BookingsHttp.getSingleBooking(id).then(result => result.data));
      await this.setManageBookingDialog(true);
    },
    async approveInvoice() {
      try {
        this.isSaving = true;
        await XeroHttp.approveSendBooking(this.activeBooking.xeroInvoiceNumber, this.activeBooking);
      } catch (err) {
        this.setToast({color: 'error', text: err.response.data, show: true})
      } finally {
        this.isSaving = false;
      }
    },
    async createSplitBooking() {
      try {
        this.isSaving = true;
        const newBookingId = await BookingsHttp.createSplitBooking(this.activeBooking).then(result => result.data);
        this.isSendingToXero = true;
        const invoice = await XeroHttp.getInvoice(this.activeBooking.xeroInvoiceNumber).then(result => result.data);
        this.activeBooking._id = newBookingId.insertedId;
        this.activeBooking.primaryTrackingId = invoice.body.invoices[0].lineItems[0].lineItemID;
        await XeroHttp.splitInvoice(this.activeBooking);
        this.isSendingToXero = false;
        await BookingsHttp.updateBooking(this.activeBooking);
        this.setToast({color: 'success', text: 'Booking has been split', show: true});
        await this.setBookings(this.activeBooking.startDate);
        await this.setActiveBooking({isXeroBooking: true, customer: {}, vehicle: null});
        await this.setManageBookingDialog(false);
        this.e1 = 1;
      } catch (err) {
        this.setToast({color: 'error', text: err.response.data, show: true})
      } finally {
        this.isSaving = false;
        this.isSendingToXero = false;
      }
    }
  },

}
</script>
